import { ASSET_STATUS } from "@desp-aas/desp-ui-fwk";
import { icons } from "./icons";


// case ASSET_STATUS.rejected:
//     return ( <>The {assetLabel} is <span className="rejected">{icons.asset_status.rejected} rejected</span></>)
// case ASSET_STATUS.creation:
//     return ( <>The {assetLabel} is <span className="creating">{icons.asset_status.creation} creating</span></>)
// case ASSET_STATUS.validation:
//     return ( <>The {assetLabel} is <span className="pending">{icons.asset_status.validation} awaiting approval</span></>)
// case ASSET_STATUS.published:
//     return ( <>The {assetLabel} is <span className="published">{icons.asset_status.published} published</span></>)
// case ASSET_STATUS.modified:
//     return ( <>The {assetLabel} is <span className="modified">{icons.asset_status.modified} awaiting modification approval</span></>)

export const assetStatusLabel = (status: ASSET_STATUS) => {
    switch(status){
        case ASSET_STATUS.rejected:
            return 'rejected';
        case ASSET_STATUS.creation:
            return 'creating';
        case ASSET_STATUS.validation:
            return 'awaiting approval';
        case ASSET_STATUS.validated:
            return 'validated';
        case ASSET_STATUS.published:
            return 'published';
        default:
            return 'awaiting modification approval';
    }
}

export const assetStatusIcon = (status: ASSET_STATUS) => {
    switch(status){
        case ASSET_STATUS.rejected:
            return icons.asset_status.rejected;
        case ASSET_STATUS.creation:
            return icons.asset_status.creation;
        case ASSET_STATUS.validation:
            return icons.asset_status.validation;
        case ASSET_STATUS.published:
            return icons.asset_status.published;
        default:
            return icons.asset_status.modified;
    }
}